module.exports = __webpack_public_path__ + "static/chat-6d38105cea606b3d12c7e042960048c7.png";